export default function getClientId(): string {
  try {
    return window.ga.getAll()[0].get('clientId')
  } catch (e) {
    return ''
  }
}

export const getGA4SessionId = (): number | undefined => {
  const pattern = /_ga_(.*?)=GS\d\.\d\.(.+?)(?:;|$)/;
  const match = document.cookie.match(pattern);
  const parts = match?.[2].split('.');

  return parts?.[0] ? parseInt(parts?.[0], 10) : undefined;
};
